import { useAppContext } from '@/src/listings/components/_shared/Wrapper';
import { Stage, stageFromString } from '@eventbrite/webapp-constants';

export const useStage = (): Stage => {
  const {
    data: { stage },
  } = useAppContext();

  const stageValue = stageFromString(stage);

  return stageValue;
};
